import React, { useState, useEffect } from 'react';
// import axios from 'axios'; // <-- 1. Ya no se importa axios
import api from './apiService'; // <-- 2. Importamos nuestro 'api'
import 'bootstrap/dist/css/bootstrap.min.css';
import './ControlPanel.css';
import CashierButton from './CashierButton';
// import TextBoxDisplay from './TextBoxDisplay'; // No se usa en este componente

// 3. Componente de Modal simple (usa estilos de Bootstrap)
function ConfirmModal({ show, title, body, onConfirm, onCancel }) {
    if (!show) {
        return null;
    }

    return (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={onCancel}></button>
                    </div>
                    <div className="modal-body">
                        <p>{body}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={onConfirm}>Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}


function ControlPanel({ session }) { // <-- 4. Destructuramos 'session' de las props
    const [cashierList, setCashierData] = useState([]);
    // const apiPort = ...; // <-- 5. Eliminado. 'apiService' maneja esto.

    // 6. Nuevo estado para el modal de confirmación
    const [modalInfo, setModalInfo] = useState({
        isOpen: false,
        cashier: null,
        newStatus: 0,
        newStatusStr: ''
    });

    // 7. Creamos una función de fetch reutilizable
    const fetchCashierStats = async () => {
        try {
            // 8. Usamos 'api.get'. No se necesita URL completa ni headers.
            // 'apiService' adjuntará la baseURL de la tienda seleccionada,
            // el token de Auth y el header X-Store-ID.
            const response = await api.get('/api/cashier_stats');
            setCashierData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        // 9. El useEffect ahora es mucho más simple.
        fetchCashierStats(); // Carga inicial
        const intervalId = setInterval(fetchCashierStats, 500); // Refresco
        return () => clearInterval(intervalId); // Limpieza
    }, []); // <-- 10. Array vacío. 'apiService' obtiene los datos de sesión de localStorage,
           // por lo que este efecto no necesita volver a ejecutarse si 'session' cambia.


    // 11. Esta función AHORA solo abre el modal
    const openConfirmModal = (cashier) => {
        let new_status = 0;
        let new_status_str = "";
        if ((cashier.open_status === "OPEN") || (cashier.open_status === "PAUSED")) {
            new_status = 3; // API espera 1=OPEN, 2=PAUSED, 3=CLOSED
            new_status_str = "CERRADA";
        } else if (cashier.open_status === "CLOSED") {
            new_status = 1;
            new_status_str = "ABIERTA";
        }

        setModalInfo({
            isOpen: true,
            cashier: cashier,
            newStatus: new_status,
            newStatusStr: new_status_str
        });
    };

    // 12. Esta nueva función maneja el 'Sí' del modal
    const handleConfirmChange = async () => {
        const { cashier, newStatus } = modalInfo;
        if (!cashier) return;

        try {
            // 13. Usamos 'api.put'. Sin URL completa, sin headers.
            await api.put('/api/update_cashier_status', {
                "cashier": cashier.camera_id,
                "status": newStatus
            });
            
            // 14. Forzamos un refresco inmediato de los datos
            fetchCashierStats();

        } catch (error) {
            console.error("Error updating cashier status:", error);
        } finally {
            // 15. Cierra el modal
            closeConfirmModal();
        }
    };

    // 16. Esta nueva función maneja el 'Cancelar' del modal
    const closeConfirmModal = () => {
        setModalInfo({ isOpen: false, cashier: null, newStatus: 0, newStatusStr: '' });
    };

    // 'checkIndex' no se modifica
    function checkIndex(index, cantCol) {
        if (index % cantCol === 0) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            {/* 17. Renderizamos el modal de confirmación */}
            <ConfirmModal
                show={modalInfo.isOpen}
                title="Confirmar Cambio de Estado"
                body={`¿Está seguro que desea cambiar el estado de la CAJA ${modalInfo.cashier?.camera_id} a ${modalInfo.newStatusStr}?`}
                onConfirm={handleConfirmChange}
                onCancel={closeConfirmModal}
            />

            <div className='controlpanel-container' >
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className="col">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Panel de Control de las Cajas</h5>
                                    <p className="card-text">En esta página usted puede controlar el estado de las cajas para que el llamador pueda enviar clientes a la misma.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-center' style={{ marginTop: "20px" }}>
                        {cashierList.map((cashier, index) => (
                            <div className="col" key={cashier.camera_id || index}> {/* 18. Añadida una key más robusta */}
                                <CashierButton 
                                    cashierData={cashier} 
                                    onClick={() => openConfirmModal(cashier)} // 19. onClick ahora abre el modal
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ControlPanel;
